export default __webpack_public_path__ + "static/media/Bulb.a098ef4e.svg";